/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconVersionsFilled = createSolidComponent("versions-filled", "IconVersionsFilled", [
  [
    "path",
    {
      d: "M18 4h-6a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z",
      "stroke-width": "0",
      fill: "currentColor"
    }
  ],
  [
    "path",
    {
      d: "M7 6a1 1 0 0 1 .993 .883l.007 .117v10a1 1 0 0 1 -1.993 .117l-.007 -.117v-10a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      fill: "currentColor"
    }
  ],
  [
    "path",
    {
      d: "M4 7a1 1 0 0 1 .993 .883l.007 .117v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-8a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      fill: "currentColor"
    }
  ]
]);

export { IconVersionsFilled as default };
//# sourceMappingURL=IconVersionsFilled.js.map
